import { useEffect, useRef, useState } from 'react'
import { MoreHorizontal, Pencil, Trash2 } from 'lucide-react'

export default function RowMenu({ label = 'Actions', onEdit, onDelete }) {
  const [open, setOpen] = useState(false)
  const wrapRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false)
    }
    window.addEventListener('keydown', onKey)
    window.addEventListener('mousedown', onClick)
    return () => {
      window.removeEventListener('keydown', onKey)
      window.removeEventListener('mousedown', onClick)
    }
  }, [open])

  return (
    <div className="row-menu" ref={wrapRef}>
      <button
        type="button"
        className="icon-btn icon-btn--sm"
        aria-label={label}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <MoreHorizontal />
      </button>
      {open && (
        <div className="row-menu__panel" role="menu">
          {onEdit && (
            <button
              type="button"
              className="row-menu__item"
              role="menuitem"
              onClick={() => { setOpen(false); onEdit() }}
            >
              <Pencil size={14} /> Edit
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              className="row-menu__item row-menu__item--danger"
              role="menuitem"
              onClick={() => { setOpen(false); onDelete() }}
            >
              <Trash2 size={14} /> Delete
            </button>
          )}
        </div>
      )}
    </div>
  )
}
